import {
  Module,
  PATH_PROJECTS_SETTLEMENTS_DIRECTORY_DETAILS,
} from "@/constants";
import DefaultList from "@/components/DefaultList";
import {
  projectSettlementsRead,
  ReadProjectSettlements,
} from "@/schemas/projectSettlements";
import { ProjectSettlementService } from "@/modules/projectSettlements/service/projectSettlements";
import { useProjectSettlementsListColumnOverrides } from "@/modules/projects/hooks/useProjectSettlementsListColumnOverrides";
import { generatePath } from "react-router-dom";

const ProjectSettlementsDirectory = () => {
  const columnOverrides = useProjectSettlementsListColumnOverrides();

  return (
    <DefaultList<ReadProjectSettlements>
      schema={projectSettlementsRead}
      name="projectSettlementsDirectory"
      fetchList={ProjectSettlementService.getList}
      pathBuilder={(row) =>
        generatePath(PATH_PROJECTS_SETTLEMENTS_DIRECTORY_DETAILS, {
          settlementId: row.id,
        })
      }
      tableFeatures={{
        exportSettings: { moduleName: Module.ProjectSettlements },
      }}
      actions={[]}
      columnOverrides={columnOverrides}
    />
  );
};

export default ProjectSettlementsDirectory;
